import hoverintent from 'hoverintent';

const navItems = document.querySelectorAll('.main-menu__item a[data-dropdown]');
const background = document.querySelector('.dropdown-background');
const mainNav = document.querySelector('.main-nav');
const container = document.querySelector('.main-header');
const dropdownContainer = document.querySelector('.dropdown-container');
const dropdownRoot = document.querySelector('.dropdown-root');
let closeTimeout;
let isOpen = false;
let itemListeners = [];

function handleEnter(event) {
  clearTimeout(closeTimeout);
  closeTimeout = null;

  if (!isOpen) {
    isOpen = true;
    removeHoverIntent();
  }

  let elems = dropdownRoot.querySelectorAll('.active');
  Array.from(elems).forEach((el) => {
    el.classList.remove('active');
  });

  let navItem = event.target;
  let dropdownTarget = navItem.getAttribute('data-dropdown');
  let dropdown = dropdownRoot.querySelector(`[data-dropdown='${dropdownTarget}']`);
  let dropdownContent = dropdown.querySelector('.dropdown__content');

  const navItemPos = navItem.getBoundingClientRect();
  const contentPos = dropdownContent.getBoundingClientRect();
  const centerOfItem = navItemPos.left + navItemPos.width / 2;
  const leftOffset = centerOfItem - contentPos.width / 2;

  let coords = {
    height: contentPos.height,
    width: contentPos.width,
    left: leftOffset
  };

  background.style.setProperty('width', `${coords.width}px`);
  background.style.setProperty('height', `${coords.height}px`)
  background.style.setProperty('transform', `translateX(${coords.left}px)`);

  dropdownContainer.style.setProperty('width', `${coords.width}px`);
  dropdownContainer.style.setProperty('height', `${coords.height}px`)
  dropdownContainer.style.setProperty('transform', `translateX(${coords.left}px)`);

  dropdown.classList.add('active');
  navItem.classList.add('has-dropdown');

  if (!container.classList.contains('dropdown-active')) {
    container.classList.add('dropdown-active');
  }

  if (container.classList.contains('no-dropdown-transition')) {
    setTimeout(() => container.classList.remove('no-dropdown-transition'), 25);
  }
}

function closeDropdown() {
  const activeNavItem = mainNav.querySelector('.has-dropdown');
  if (activeNavItem) {
    activeNavItem.classList.remove('has-dropdown');
  }
  let elems = dropdownRoot.querySelectorAll('.active');
  Array.from(elems).forEach((el) => {
    el.classList.remove('active');
  });
  container.classList.remove('dropdown-active');
  container.classList.add('no-dropdown-transition');
  isOpen = false;

  removeItemListeners();
  initHoverIntent();
}

function handleLeave() {
  closeTimeout = setTimeout(closeDropdown, 200);
}

function handleEnterDropdownContainer() {
  clearTimeout(closeTimeout);
  closeTimeout = null;
}

function handleLeaveDropdownContainer() {
  closeTimeout = setTimeout(closeDropdown, 200);
}

function initHoverIntent() {
  itemListeners = [];
  if (navItems.length) {
    navItems.forEach(item => itemListeners.push(hoverintent(item, handleEnter).options({ timeout: 200 })));
  }
}

function removeHoverIntent() {
  if (itemListeners) {
    itemListeners.forEach(listener => listener.remove());
  }
  addItemListeners();
}

function addItemListeners() {
  navItems.forEach(item => item.addEventListener('mouseenter', handleEnter));
  navItems.forEach(item => item.addEventListener('mouseleave', handleLeave));
}

function removeItemListeners() {
  navItems.forEach(item => item.removeEventListener('mouseenter', handleEnter));
  navItems.forEach(item => item.removeEventListener('mouseleave', handleLeave));
}

function init() {
  initHoverIntent();
  dropdownContainer.addEventListener('mouseenter', handleEnterDropdownContainer);
  dropdownContainer.addEventListener('mouseleave', handleLeaveDropdownContainer);
}

export default {
  init
};



// WEBPACK FOOTER //
// ./src/js/vanilla/dropdown-menu.js